import { useModalStore } from "@/stores/components/modalStore";

export default () => {
  const toggleActionModal = (
    toShow,
    data = {
      title: "",
      text: "",
      primaryBtnText: null,
      primaryBtnAction: null,
      secondaryBtnText: null,
      secondaryBtnAction: null,
      alignment: {},
    }
  ) => {
    const store = useModalStore();
    store.$state.actionModal.toShow = toShow;
    store.$state.actionModal.options = data;
  };

  const showWalletModal = (
    data = {
      title: "",
      text: "",
      primaryBtnText: null,
      primaryBtnAction: null,
      secondaryBtnText: null,
      secondaryBtnAction: null,
      alignment: {},
    }
  ) => {
    const store = useModalStore();
    store.$state.walletModal.toShow = true;
    store.$state.walletModal.options = data;
  };

  const hideWalletModal = () => {
    const store = useModalStore();
    store.$state.walletModal.toShow = false;
  };

  const hideSuccessModal = () => {
    const store = useModalStore();
    store.$state.successModal.toShow = false;
    store.$state.successModal.progressLevel = "";
  };

  const showSuccessModal = ({ progressLevel }) => {
    const store = useModalStore();
    store.$state.successModal.toShow = true;
    store.$state.successModal.progressLevel = progressLevel;
  };

  return {
    toggleActionModal,
    showWalletModal,
    hideWalletModal,
    hideSuccessModal,
    showSuccessModal,
  };
};
